import { defineMessages } from 'react-intl';

export const missingWarehouseBannerMessages = defineMessages({
  title: {
    id: 'MYWRVb',
    description: 'Title for missing warehouse banner when Ready to Pick action is selected',
    defaultMessage: 'Ship From Location Required',
  },
  description: {
    id: '81/wZG',
    description: 'Description for missing warehouse banner when Ready to Pick action is selected',
    defaultMessage:
      'To use the "Ready to Pick" action, you must first add a Ship From Location. This automation rule will not run without a configured warehouse.',
  },
  addShipFromButton: {
    id: 'CyELWQ',
    description: 'Button text to add a Ship From Location',
    defaultMessage: 'Add Ship From Location',
  },
});
